import React, { useCallback } from "react";
import { graphql, useLazyLoadQuery, useMutation } from "react-relay";
import { LazyQueryNetworkBoundrary } from "../../components/mobile/QueryNetworkBoundrary";
import { TodoEditScreenProps } from "./paramList";
import { TodoEditLinkProductQuery } from "./__generated__/TodoEditLinkProductQuery.graphql";
import { LinkProductComponent } from "./LinkProductComponent";
import { usePersistedEmployeeId } from "@/src/OS/Login/usePersistedEmployeeId";

function InnerTodoEditLinkProductComponent({
  id,
  fetchKey,
  inBottomSheet,
  goBack,
}: {
  id: string;
  fetchKey: string;
  inBottomSheet: boolean;
  goBack: () => void;
}) {
  const data = useLazyLoadQuery<TodoEditLinkProductQuery>(
    graphql`
      query TodoEditLinkProductQuery($todoId: ID!) {
        todo(id: $todoId) @required(action: THROW) {
          linkedProducts {
            id
          }
        }
      }
    `,
    {
      todoId: id,
    },
    {
      fetchKey,
      fetchPolicy: "store-and-network",
    }
  );
  const { currentEmployeeId } = usePersistedEmployeeId();

  const [linkProduct] = useMutation(graphql`
    mutation TodoEditLinkProductMutation(
      $todoId: ID!
      $productId: ID!
      $employeeId: ID
    ) {
      todo(todoId: $todoId, employeeId: $employeeId) {
        linkProduct(productId: $productId) {
          id
          linkedProducts {
            id
          }
        }
      }
    }
  `);

  const onPressProduct = useCallback(
    (product: { id: string }) => {
      linkProduct({
        variables: {
          todoId: id,
          productId: product.id,
          employeeId: currentEmployeeId,
        },
        onCompleted: () => {
          goBack();
        },
      });
    },
    [id, linkProduct, goBack, currentEmployeeId]
  );

  return (
    <LinkProductComponent
      linkedProductIds={data.todo.linkedProducts.map((p) => p.id)}
      onPressProduct={onPressProduct}
      inBottomSheet={inBottomSheet}
    />
  );
}

export function TodoEditLinkProductComponent(props: {
  id: string;
  inBottomSheet: boolean;
  goBack: () => void;
}) {
  return (
    <LazyQueryNetworkBoundrary newFetchKeyOnNavigation>
      {(fetchKey) => (
        <InnerTodoEditLinkProductComponent
          inBottomSheet={props.inBottomSheet}
          goBack={props.goBack}
          id={props.id}
          fetchKey={fetchKey}
        />
      )}
    </LazyQueryNetworkBoundrary>
  );
}

export function TodoEditLinkProduct(
  props: TodoEditScreenProps<"TodoEditLinkProduct">
) {
  return (
    <TodoEditLinkProductComponent
      id={props.route.params.id}
      inBottomSheet={false}
      goBack={props.navigation.goBack}
    />
  );
}
